import _ from 'lodash'
import { DirectiveOptions } from 'vue'

export interface BreakpointElement extends HTMLElement {
    breakpoint?: () => void
}

const update = (el: HTMLElement, { value }: any): void => {
    const width = el.clientWidth
    let modified = false
    _.forEach(value, (v, k) => {
        if (k === 'callback') return
        if (width >= v && !el.classList.contains(k)) {
            el.classList.add(k)
            modified = true
        } else if (width < v && el.classList.contains(k)) {
            el.classList.remove(k)
            modified = true
        }
    })
    if (modified && value.callback) {
        value.callback(el.classList)
    }
}

const breakpoints: DirectiveOptions = {
    inserted(el: BreakpointElement, { value }: any): void {
        value = value || {
            'size-xs': 0,
            'size-sm': 200,
            'size-md': 600,
            'size-lg': 900,
            'size-xl': 1200
        }
        if (!el.breakpoint) {
            el.breakpoint = () => update(el, { value })
        }
        // call right now
        el.breakpoint()
        // call initially on next available update
        requestAnimationFrame(el.breakpoint)
        window.addEventListener('resize', el.breakpoint)
    },

    update(el: BreakpointElement): void {
        if (el.breakpoint) {
            el.breakpoint()
        }
    },

    unbind(el: BreakpointElement): void {
        if (el.breakpoint) {
            window.removeEventListener('resize', el.breakpoint)
        }
    }
}

export default breakpoints
